export function renderDisclaimer(state : any) {

    const totalMeses = Object.keys(state?.zones?.meses || []).length
    if (state.escrutat < totalMeses && totalMeses > 0) {
        const e = document.getElementById('append-provisional-results')
        if (e) {
            e.innerHTML = `- Escrutades <strong>${state.escrutat}</strong> de <strong>${totalMeses}</strong> meses`
        }
    }
}
